// extracted by mini-css-extract-plugin
module.exports = {"priceList":"PriceList_priceList__1j9Cu","priceItem":"PriceList_priceItem__1TG_Q"};